import { render, staticRenderFns } from "./VSearchButton.vue?vue&type=template&id=656c9291&scoped=true&"
import script from "./VSearchButton.vue?vue&type=script&lang=js&"
export * from "./VSearchButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656c9291",
  null
  
)

export default component.exports